// export const PERMISSION_CHANNEL = 'permissionChannel'; // 用于同步权限信息的跨tab通信频道名称
export const LOGIN_STATUS_CHANNEL = 'loginStatusChannel'; // 登录状态的跨tab通信频道名称
export const CURRENT_USER_CHANNEL = 'currentUserChannel'; // 用于同步初始用户数据的跨tab通信频道名称
export const VERSION_REFRESH_SYNC_CHANNEL = 'versionRefreshSyncChannel'; // 用于同步版本刷新的跨tab通信频道名称
